export const formatCompact = (n) => {
  const num = Number(n || 0);
  const abs = Math.abs(num);
  if (abs >= 1_000_000_000) return `${(num / 1_000_000_000).toFixed(2)}b`;
  if (abs >= 1_000_000) return `${(num / 1_000_000).toFixed(2)}m`;
  if (abs >= 1_000) return `${(num / 1_000).toFixed(2)}k`;
  return `${num.toFixed(2)}`;
};

export const formatCurrencyCompact = (n) => {
  const num = Number(n || 0);
  const abs = Math.abs(num);
  if (abs >= 1_000) return `$${formatCompact(num)}`;
  return `$${num.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

export const formatPercent = (n) => {
  const num = Number(n || 0);
  return `${num.toFixed(2)}%`;
};

export const formatCurrencyPrecise = (n, opts) => {
  const num = Number(n || 0);
  const abs = Math.abs(num);
  const min = opts?.min ?? (abs < 0.01 ? 6 : abs < 1 ? 4 : 2);
  const max = opts?.max ?? (abs < 0.01 ? 6 : abs < 1 ? 4 : 2);
  return `$${num.toLocaleString(undefined, { minimumFractionDigits: min, maximumFractionDigits: max })}`;
};
